import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Beaker } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { isEmbeddedSiteView } from '../lib/avatarEmbed';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const embedded = isEmbeddedSiteView();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (embedded) return null;

  const isHome = location.pathname === '/';

  return (
    <motion.nav
      className={`fixed w-full z-50 transition-colors duration-300 ${
        isHome
          ? 'bg-gradient-to-b from-black/80 to-transparent pointer-events-none'
          : isScrolled
            ? 'bg-black/95 backdrop-blur-md'
            : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${isHome ? 'pointer-events-auto' : ''}`}>
        <div className="flex items-center h-16 sm:h-20">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="relative group"
          >
            <Link
              to="/"
              className="flex items-center"
              aria-label="SELF Labs home"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              <div
                className="absolute inset-0 rounded-full blur-xl opacity-60
                group-hover:blur-2xl group-hover:scale-150 transition-all duration-300"
                style={{
                  background:
                    'radial-gradient(circle, var(--glow-purple) 0%, var(--glow-orange) 50%, var(--glow-blue) 100%)',
                }}
              />

              <motion.div
                animate={{
                  rotate: [0, 5, -5, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut',
                }}
                className="relative"
              >
                <Beaker
                  className="h-8 w-8 text-white drop-shadow-[0_0_8px_rgba(255,255,255,0.35)]
                  group-hover:drop-shadow-[0_0_14px_rgba(255,255,255,0.55)]
                  transition-all duration-300"
                />

                <motion.div
                  className="absolute bottom-0 left-1/2 w-1 h-1 bg-white/60 rounded-full opacity-0
                    group-hover:opacity-100 transition-opacity duration-300"
                  animate={{
                    y: [-20, -30],
                    opacity: [0, 1, 0],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    repeatDelay: 0.5,
                  }}
                />
                <motion.div
                  className="absolute bottom-0 left-1/4 w-1 h-1 bg-white/50 rounded-full opacity-0
                    group-hover:opacity-100 transition-opacity duration-300"
                  animate={{
                    y: [-15, -25],
                    opacity: [0, 1, 0],
                  }}
                  transition={{
                    duration: 1.2,
                    repeat: Infinity,
                    repeatDelay: 0.3,
                  }}
                />
              </motion.div>
            </Link>
          </motion.div>
        </div>
      </div>
    </motion.nav>
  );
}
